import { useRef } from 'react';
import { useDepsChanged } from './useDepsChanged';

/**
 * Returns true if `val` is or has ever been true.  If `options.reset` is true,
 * or `options.deps` changes, and `val` is false, the return value will reset
 * back to false.
 */
export function useIfEverTrue(val: boolean, options: { reset?: boolean; deps?: any[] } = {}) {
  const answer = useRef(val);

  const depsChanged = useDepsChanged(options.deps || []);
  const reset = options.reset || depsChanged;

  if (reset) {
    answer.current = val;
  } else {
    answer.current = answer.current || val;
  }

  return answer.current;
}
